import { Auth } from 'aws-amplify';
import jwtDecode from 'jwt-decode';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

export default {
    signIn: async function (email, password) {
        try {
            let cognitoUser = await Auth.signIn(email, password);
            return cognitoUser;
        }
        catch (error) {
            console.log('error onSignIn', error);
            throw error;
        }
    },
    signInPasswordless: async function (email) {
        try {
            let cognitoUser = await Auth.signIn(email);
            return cognitoUser;
        }
        catch (error) {
            console.log('error signInPasswordless', error);
            throw error;
        }
    },
    signInWithGoogle: async function () {
        try {
            await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
        }
        catch (error) {
            console.log('error federatedSignIn Google', error);
            throw error;
        }
    },
    signInWithFacebook: async function () {
        try {
            await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
        }
        catch (error) {
            console.log('error federatedSignIn Facebook', error);
            throw error;
        }
    },
    signOut: async function () {
        try {
            let signoutPromise = await Auth.signOut({ global: true });
            return signoutPromise;
        }
        catch (error) {
            console.log('error signOut', error);
            throw error;
        }
    },
    checkAnswer: async function (cognitoUser, secret) {
        try {
            // Send the answer to the User Pool
            // This will throw an error if it’s the 3rd wrong answer
            await Auth.sendCustomChallengeAnswer(cognitoUser, secret);
        }
        catch (error) {
            console.log('error checkAnswer', error);
            throw error;
        }

        // It we get here, the answer was sent successfully,
        // but it might have been wrong (1st or 2nd time)
        // So we should test if the user is authenticated now
        try {
            // This will throw an error if the user is not yet authenticated:
            let sessionPromise = await Auth.currentSession();
            return sessionPromise;
        }
        catch (error) {
            console.log('Apparently the user did not enter the right code');
            throw error;
        }
    },
    getCurrentAuthUser: async function () {
        try {
            //this will return an object containing all the info regarding the user (attributes, pool, datakey, storage, ...)
            let cognitoUser = await Auth.currentAuthenticatedUser();
            return cognitoUser;
        }
        catch (error) {
            console.log('error getCurrentAuthUser', error);
            throw error;
        }
    },
    getCurrentAuthUserHeader: async function () {
        try {
            //this will return an object containing the 3 tokens: accessToken - idToken - refreshToken
            let sessionPromise = await Auth.currentSession();
            let idToken = sessionPromise.getIdToken().jwtToken;
            return 'Bearer ' + idToken;
        }
        catch (error) {
            console.log('error getCurrentAuthUserHeader', error);
            throw error;
        }
    },
    getCurrentAuthUserInfo: async function() {
        try {
            let info = await Auth.currentUserInfo();
            return info;
        }
        catch (error) {
            console.log('error getCurrentAuthUserInfo', error);
            throw error;
        }
    },
    getCurrentAuthUserInfo_Confirmed: async function () {
        try {
            let info = await Auth.currentUserInfo();
            let hasAttribute = info && Object.prototype.hasOwnProperty.call(info.attributes, 'custom:user_confirmed');
            let isValidAttribute = info && (info.attributes['custom:user_confirmed'] && parseInt(info.attributes['custom:user_confirmed'], 10) !== 0);
            return hasAttribute && isValidAttribute;
        }
        catch (error) {
            console.log('error getCurrentAuthUserInfo_Confirmed', error);
            throw error;
        }
    },
    getCurrentAuthUserInfo_MarketingConsent: async function () {
        try {
            let info = await Auth.currentUserInfo();
            let hasAttribute = Object.prototype.hasOwnProperty.call(info.attributes, 'custom:marketing_consent');
            let isValidAttribute = (info.attributes['custom:marketing_consent'] && parseInt(info.attributes['custom:marketing_consent'], 10) !== 0);
            return hasAttribute && isValidAttribute;
        }
        catch (error) {
            console.log('error getCurrentAuthUserInfo_MarketingConsent', error);
            throw error;
        }
    },
    getDecodedSessionToken(token) {
        let payload = jwtDecode(token);
        return payload;
    },
    isLoggedIn: async function () {
        try {
            await Auth.currentAuthenticatedUser();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    
}